import { ChartOptions } from "chart.js"

export const fixedOptions: ChartOptions<"doughnut"> = {
  responsive: true,
  aspectRatio: 2,
  maintainAspectRatio: false,
  rotation: -90,
  circumference: 180,
  cutout: 65,
  plugins: {
    title: {
      display: false,
    },
    datalabels: {
      display: false,
    },
  },
}
